import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiCouponRequestPostParams,
  ApiCouponRequestPostResponse,
} from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/api/apiCouponRequest.types'

export default {
  post({ data, couponRequestId }: ApiCouponRequestPostParams) {
    return axiosClient.post<ApiCouponRequestPostResponse>(`/ajax/club/coupon_request/${couponRequestId}/online_payment/`, data, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  },
}
